import { render, staticRenderFns } from "./PricingPlan.vue?vue&type=template&id=2774b47a&scoped=true"
import script from "./PricingPlan.vue?vue&type=script&lang=js"
export * from "./PricingPlan.vue?vue&type=script&lang=js"
import style0 from "./PricingPlan.vue?vue&type=style&index=0&id=2774b47a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2774b47a",
  null
  
)

/* custom blocks */
import block0 from "./PricingPlan.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports